import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export async function joinWaitlist(email, source = "shop_coming_soon") {
  const { data } = await api.post("/waitlist", { email, source });
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function submitApplication(payload) {
  const { data } = await api.post("/applications", payload);
  return data;
}
